<template>
<div class="container-fluid">
	<notification-toolbar heading="Alerts"></notification-toolbar>

	<div class="container">
		<!--<div class="float-right mb-2">
			<button class="btn btn-light btn-sm">
				Mark all as read
			</button>
		</div>
		<div style="clear: both;"></div>
		-->

		<p v-if="loading">
			Loading alerts...
		</p>
		<div v-else>
			<div class="float-right notification-controls">
				<div class="d-flex align-items-center">
					<button class="btn btn-sm btn-light" type="button" v-on:click="dismissAll">
						Dismiss All
					</button>
					<label style="margin-bottom: 0;margin-left: 10px;">
						<input type="checkbox" v-model="showDismissed" v-on:change="fetchData(true)">
						Show dismissed alerts
					</label>
				</div>
			</div>
			<div v-for="(group,index) in notificationGroups" class="mb-4">
				<h3>{{group.heading}}</h3>

				<ul v-if="group.notifications.length > 0" class="notifications list-group">
					<li v-for="item in group.notifications" 
						class="list-group-item notification-item" 
						:class="{'dismissed-notification':item.is_dismissed == 1}">

						<div class="custom-flex main-flex">
							<component :is="getNotificationLinkType(item)" :to="item.link" :href="item.link" :target="item.new_tab == 1 ? '_blank' : null">

								<div class="notification-inner">
									<div class="d-flex flex-row align-items-center">
										<i class="fa fa-fw mr-3" :class="item.icon"></i>
										<h3>{{item.module}}</h3>
									</div>
									<div class="notification-message">
										{{item.message}}
									</div>
									<div v-if="'is_approved' in item.meta && !item.meta.is_approved && !('rejected_by' in item.meta) && hasModulePermWrite('Users')" class="ml-2">
										<button class="btn btn-sm btn-light" v-on:click="toggleVacationApproval(item,item.meta.event_id,1)">
											<i class="fa fa-check"></i>
											Approve
										</button>
										<button  class="btn btn-sm btn-light" v-on:click="toggleVacationApproval(item,item.meta.event_id,0)">
											<i class="fa fa-times"></i>
											Reject
										</button>
									</div>
								</div>

							</component>
							<div class="custom-flex meta-info">
								<div class="mr-3">
									<div v-if="'approvedByUserName' in item && item.approvedByUserName" class="text-success">
										Approved by {{ item.approvedByUserName }}
									</div>
									<div v-if="'rejectedByUserName' in item && item.rejectedByUserName" class="text-danger">
										Rejected by {{ item.rejectedByUserName }}
									</div>
								</div>

								<div class="text-muted text-right mr-3">{{formatDateTimeToLocal(item.created_at)}}</div>
								<a v-if="item.is_dismissed == 0" href="#" v-on:click.prevent="dismissNotification(item)">
									<i class="fa fa-times"></i>
									Dismiss
								</a>
								<div v-else class="text-muted">Dismissed</div>
							</div>
						</div>
					</li>
				</ul>
				<p v-else>No alerts here.</p>

				<p v-if="index == 0" class="mt-2">Want to customize what notications you receive? Flip over to the <router-link to="/notifications/settings">Notification Settings</router-link> tab.</p>
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
import NotificationToolbar from  "@/pages/notifications/NotificationToolbar"

import ScheduleMixins from "@/mixins/ScheduleMixins.js"

export default {
	name: "NotificationCenter",
	components: {
		NotificationToolbar
	},
	mixins: [ScheduleMixins],
	data() {
		return {
			notifications: [],
			notificationLimit: 50,
			loading: true,
			showDismissed: false,
			appDomain: window.location.hostname,
      notificationIdMapToUserId: {},
      users: []
		}
	},
	computed: {
		notificationGroups() {
			let vm = this

			//split notifications into today's and past
			let mutated = this.notifications.map(noti => {
				if (noti.module == 'Projects') 
					noti.icon = "fa-cubes"
				
				switch (noti.module) {
					case "Jobs":
						noti.icon = "fa-cubes";
						break;
					case "Services":
					case "Service Invoices":
						noti.icon = "fa-wrench";
						break;
					case "Equipment":
						noti.icon = "fa-truck";
						break;
					case "Certificates":
						noti.icon = "fa-id-card-o";
						break;
					case "Users":
						noti.icon = "fa-users";
						break;
					case "Library":
						noti.icon = "fa-book";
						break;
					case "Company Forms":
						noti.icon = "fa-clipboard-check";
						break;
					default:
						noti.icon = "fa-bell";
				}

				noti.meta = {}
				try {
					noti.meta = JSON.parse(noti.meta_json)
				}
				catch (e) {}

        noti.approvedByUserName = ""
        noti.rejectedByUserName = ""

        if (noti.event == 'Users:vacation:scheduled' && noti.id in vm.notificationIdMapToUserId) {
          let userId = vm.notificationIdMapToUserId[noti.id]

          let user = vm.users.find(user => user.id == userId)
          if (user) {
            if ("approved_by" in noti.meta && noti.meta.approved_by > 0)
              noti.approvedByUserName = user.first_name + " " + user.last_name

            if ("rejected_by" in noti.meta && noti.meta.rejected_by > 0) {
              noti.rejectedByUserName = user.first_name + " " + user.last_name
            }
          }
        }
        return noti
      })

			//split into sections now
			let todays = {
				heading: "Today's Alerts",
				notifications: mutated.filter(noti => {

					if (vm.moment.utc(noti.created_at).local().isAfter(vm.moment().subtract(24,"hours")))
						return true
					else
						return false
				})
			}

			let older = {
				heading: "Older Alerts",
				notifications: mutated.filter(noti => {

					if (vm.moment.utc(noti.created_at).local().isAfter(vm.moment().subtract(24,"hours")))
						return false
					else
						return true
				})
			}

			return [todays,older]
		}
	},
	methods: {
		userIdsToFetchAndSetMap() {
			let vm = this

			this.notifications.map(noti => {
				try {
					noti.meta = JSON.parse(noti.meta_json)
				}
				catch (e) {
					noti.meta = {}
				}
				return noti
			})
			.filter(noti => ('is_approved' in noti.meta))
			.forEach(noti => {
				let theNoti = this.notifications.find(noti => {
					if ("approved_by" in noti.meta && noti.meta.approved_by > 0)
						return noti.meta.approved_by
					else if ("rejected_by" in noti.meta && noti.meta.rejected_by > 0)
						return noti.meta.rejected_by
				})

				if (theNoti) {
					if ("meta" in theNoti && theNoti.meta && "approved_by" in theNoti.meta && theNoti.meta.approved_by)
						vm.notificationIdMapToUserId[noti.id] = theNoti.meta.approved_by
					else if ("meta" in theNoti && theNoti.meta && "rejected_by" in theNoti.meta && theNoti.meta.rejected_by)
						vm.notificationIdMapToUserId[noti.id] = theNoti.meta.rejected_by
				}
			})

			return Object.keys(vm.notificationIdMapToUserId).map(key => vm.notificationIdMapToUserId[key])
		},
		getNotificationLinkType(item) {
			if ("link" in item && item.link)
				return item.link.search('http') >= 0 || item.link.search('https://'+this.appDomain) >= 0 ? 'a' : 'router-link'
			else return "div"
		},
		dismissNotification(item) {
			let vm = this

			this.postData("Notification/dismiss",{id:item.id},true).then(response => {
				if (response.success) 
					item.is_dismissed = 1
			})
		},
		dismissAll() {
			let vm = this
			this.postData("Notification/dismiss-all",{},true).then(response => {
				if (response.success) 
					vm.fetchData(true)
			})
		},
		toggleVacationApproval(item,event_id,approve) {
		  let vm = this
			this.approveRejectVacation(event_id,approve).then(response => {
				if (response.success) {
					//vm.dismissNotification(item)
					vm.fetchData(true)
				}
			})
		},
		fetchData(spinner) {
			let vm = this

			let promises = [
				this.fetchNotifications(false,this.notificationLimit,this.showDismissed)
			]

			if (spinner)
				this.spinner(true)

			Promise.all(promises).then(responses => {
				if (spinner)
					vm.spinner(false)
				vm.notifications = responses[0].data

        let userIds = vm.userIdsToFetchAndSetMap()

        let params = {
				  filters: [
				     ["id",userIds]
          ],
          fields: ["id","slug","first_name","last_name"]
        }

        vm.getJSON("User/get",params).then(response => {
          if (response.success)
            vm.users = response.data
        })

				vm.loading = false
			})
		}
	},
	created() {
		this.fetchData(true)
	}
}
</script>

<style type="text/css" scoped>
	.notification-item h3, .notification-item p {
		margin-bottom: 0;
		font-size: 14pt;
		font-weight: 600;
		margin-right: 15px;
	}

	.notification-item a {
		color: inherit;
	}

	.notification-item a:hover {
		text-decoration: none;
	}

	.notification-item:hover {
		background-color: #e2ecf1;
		box-shadow: 0 0 5px -2px rgba(10,10,10,0.3);
	}

	.notification-item.recent-notification {
		background-color: #e2ecf1;
	}

	.notification-item.dismissed-notification {
		background-color: #efefef;
	}

	.custom-flex {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.notification-item .notification-inner {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	@media (max-width: 991px) {
		.custom-flex.main-flex {
			flex-direction: column;
			align-items: flex-start;
		}

		.custom-flex.meta-info {
			width: 100%;
			margin-top: 10px;
		}

		.notification-message {
			width: calc(100% - 37px);
			margin-top: 5px;
			margin-left: 37px;
		}

		.list-group-item {
			padding: 12px;
		}

		.notification-controls {
			margin-bottom: 15px;
			float: none!important;
		}
	}

	@media (max-width: 400px) {
		.notification-item .notification-inner {
			flex-direction: column;
		}
	}
</style>